export const InfoWhiteSVG = (props) => (
  <svg height="17" viewBox="0 0 17 17" width="17" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1 1)"
    >
      <path d="m7.5 12.5v-6"/>
      <path d="m7.5 4.5v-1"/>
      <path d="m15.5 7.75038123c0 4.28043677-3.4699444 7.75038127-7.75038123 7.75038127-4.27967436 0-7.74961877-3.4699445-7.74961877-7.75038127 0-4.28043682 3.46994441-7.75038123 7.74961877-7.75038123 4.28043683 0 7.75038123 3.46994441 7.75038123 7.75038123z"/>
    </g>
  </svg>
);
